// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/competition/:id',
        name: 'competition',
        component: () => import('../views/Competition.vue')
    },
    {
        path: '/leaderboard/:id',
        name: 'leaderboard',
        component: () => import('../views/Leaderboard.vue')
    },
    {
        path: '/groups/:id?',
        name: 'groups',
        component: () => import('../views/Groups.vue')
    },
    {
        path: '/player/:scoreCardId',
        name: 'player',
        component: () => import('../views/Player.vue'),
        props: true
    },
    {
        path: '/display/:id?',
        name: 'display',
        component: () => import('../views/Display.vue')
    },
    {
        path: '/display/:id?',
        name: 'display',
        component: () => import('../views/Display.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('../views/NotFound.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
